module.exports = __webpack_public_path__ + "img/golden-bull.8bbbaffe.png";